// src/steps/ParentInfoStep.tsx
import React from "react";
import Input from "../components/ui/Input";
import Select from "../components/ui/Select";
import type { ParentInfoState } from "../wizard/wizardState";
import { getPickupTypeOptions } from "../constants/pickupTypes";
import { getPasswordLabel } from "../utils/passwordLabelHelper";
import { formatPhoneNumber } from "../utils/phoneFormatter";

type Props = {
  value: ParentInfoState;
  onChange: (next: ParentInfoState) => void;
  errors: Record<string, string>;
};

export default function ParentInfoStep({ value, onChange, errors }: Props) {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Input
          label="First Name"
          value={value.firstName}
          onChange={(e) => onChange({ ...value, firstName: e.target.value })}
          error={errors.firstName}
        />
        <Input
          label="Last Name"
          value={value.lastName}
          onChange={(e) => onChange({ ...value, lastName: e.target.value })}
          error={errors.lastName}
        />
      </div>

      <Input
        label="Email"
        value={value.email}
        onChange={(e) => onChange({ ...value, email: e.target.value })}
        error={errors.email}
        inputMode="email"
        autoComplete="email"
      />

      <Input
        label="Phone"
        value={value.phone}
        onChange={(e) => onChange({ ...value, phone: formatPhoneNumber(e.target.value) })}
        error={errors.phone}
        inputMode="tel"
        autoComplete="tel"
        placeholder="(xxx) xxx-xxxx"
      />

      <Input
        label="Relation to Child"
        value={value.relationToChild}
        onChange={(e) => onChange({ ...value, relationToChild: e.target.value })}
        error={errors.relationToChild}
        placeholder="Mother, Father, Guardian, etc."
      />

      <Select
        label="Pickup Type"
        value={value.pickupType}
        onChange={(e) => onChange({ ...value, pickupType: e.target.value })}
        error={errors.pickupType}
        placeholder="Select pickup type"
        options={getPickupTypeOptions()}
      />

      <Input
        label={getPasswordLabel(value.pickupType)}
        value={value.passphrase}
        onChange={(e) => onChange({ ...value, passphrase: e.target.value })}
        error={errors.passphrase}
      />
    </div>
  );
}
